import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { Grid, SideSheet, Cover } from 'ui-toolkit';
import { IThirdPartyContactData } from '../../../../types/contacts/IThirdPartyContact';
import { thirdPartyContactsFormValidation } from '../../../../validation/order/ThirdPartyContactsFormValidation';
import { ThirdPartyContactForm } from './ThirdPartyContactForm';
import { DeleteContactWarning } from '../subComponents/DeleteContactWarning';
import { SideSheetEditContactFormFooter } from '../../../shared/SideSheetEditContactFormFooter';
import { IEditContactFormProps } from '../interfaces/IEditContactFormProps';
import { EditContactFormStatusWrapper } from '../subComponents/EditContactFormStatusWrapper';

interface IEditThirdPartyContactFormProps extends IEditContactFormProps {
  initialData: IThirdPartyContactData;
}

export const EditThirdPartyContactForm: React.FC<IEditThirdPartyContactFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  onDelete,
  updateFetchError,
  updateFetchStatus,
  deleteFetchError,
  deleteFetchStatus,
  onResetDeleteContact,
}) => {
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const showWarning = () => setShowDeleteWarning(true);
  const onDeleteCancelled = () => {
    setShowDeleteWarning(false);
    onCancel();
  };
  const onDeleteAndCancel = () => {
    onResetDeleteContact();
    onCancel();
  };
  return (
    <Formik
      initialValues={initialData}
      validateOnMount={true}
      validationSchema={thirdPartyContactsFormValidation}
      onSubmit={onSubmit}
      onReset={onCancel}
    >
      <Form>
        <SideSheet
          title={'Edit Contact'}
          onClose={onCancel}
          footer={
            <SideSheetEditContactFormFooter
              onCancel={onCancel}
              saveButtonText={'Save and Update'}
              showWarning={showWarning}
            />
          }
        >
          <Grid>
            <EditContactFormStatusWrapper
              fetching={updateFetchStatus.fetching || deleteFetchStatus.fetching}
              updateFetchedSuccess={updateFetchStatus.success}
              deleteFetchedSuccess={deleteFetchStatus.success}
              fetchError={updateFetchError || deleteFetchError}
              updateSuccessMessage={'Contact Updated!'}
              deleteSuccessMessage={'Contact Deleted!'}
              onResetDeleteAndCancel={onDeleteAndCancel}
            />
            <ThirdPartyContactForm showAddressFields disableEmail />
            {showDeleteWarning && (
              <Cover>
                <DeleteContactWarning
                  contactId={initialData.id}
                  onCancel={onDeleteCancelled}
                  onDelete={onDelete}
                  contactName={`${initialData.firstName} ${initialData.lastName}`}
                />
              </Cover>
            )}
          </Grid>
        </SideSheet>
      </Form>
    </Formik>
  );
};
